
import React, {useState, useEffect} from 'react';

import GLOBALS from '../elements/Globals';
import Loader from './Loader';
import img5 from './img/ylogo.png'
import { Link } from 'react-router-dom';
import { ReactSession } from 'react-client-session';

import $ from 'jquery';

const createMarkup = (htmlString) => {
  return { __html: htmlString };
};

const SignIn = (props) => {

  ReactSession.setStoreType("localStorage");

  const [loading, setLoading] = useState(false);
  const [pagedata, setPagedata ]= useState("");
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [returnmessage, setReturnmessage] = useState('');

  // Event handler for input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setEmail(value);
    } else if (name === 'password') {
      setPassword(value);
    }
  };

  $('#togglePassword').on('click', function(event){
    event.stopImmediatePropagation();
    if($('#userpassword').attr('type') == 'password'){
      $('#passwordShow').hide();
      $('#passwordHide').show();
      $('#userpassword').attr('type', 'text');
    }else{
      $('#passwordShow').show();
      $('#passwordHide').hide();
      $('#userpassword').attr('type', 'password');
    }
  })

  async function sendForm() {
      setLoading(true)
      let apiUrl = 'login';
      const url = GLOBALS.API_BASE_URL+apiUrl;
      try {

        $.ajax({
          type: "POST",
          url: url,
          data: 'email='+email+'&password='+password,
          cache: false,
          success: function(data){
             if(data.status == 1){
              ReactSession.set("user", data.user);
              ReactSession.set("loggedin", 1);
              setEmail('');
              setPassword('');
              window.location.href = "";
             }else{
              var message = data.message;
              setReturnmessage(message);
              $('#errorMessageSection').show();
              setLoading(false)
             }
          }
        });
      } catch (error) {
        console.error(error.message);
      }
    }
  
    // Event handler for form submission
    const handleSubmit = (event) => {
      event.preventDefault();
      sendForm();
    };
  
  return (
    <>
    <div className='sing_in_contend'>
    <link rel="stylesheet" href="/assets/css/login-style.css?v=20220823.00"></link>
      <header className="header">
        <div aria-label="Mvpboxing Logo" className="logo logo-primary" data-testid="-logo" id="logo" role="img">
          <Link to="/">
          <img className="login_logo_image ls-is-cached lazyloaded" data-src="https://www.mvpboxing.com/assets/images/logo-new.png" alt="MVP BOXING" src="https://www.mvpboxing.com/assets/images/logo-new.png" />
        </Link>
        </div>
      </header>
       <div className="BodyContainer-sc-4rz3ia-0 sing_in_box">
        <div data-testid="sign-in">
        <div className="styles__Container-sc-yjr19k-1 sing_in_box_contend">
       <div className="styles__ColumnContainer-sc-yjr19k-2 sign_in_top_contend">
       <div data-testid="logo-container" className="styles__LogoContainer-sc-11jlv0z-0 sign_in_top_contend_img_box">
       </div>
       <h1 role="header" className="styles__HeaderText-sc-yjr19k-5 sign_in_top_contend_text"> Sign In</h1></div>
       <div id="errorMessageSection" class="alert alert-danger" role="alert">
        {returnmessage}
      </div>
       <form method='post' onSubmit={handleSubmit}>
       <div className="styles__InputBoxWrapper-sc-yjr19k-3 sign_in_center_contend">
        <div className="styles__Container-sc-dzwwyq-0 sign_in_center_contend_box">
          <div className="styles__Container-sc-dzwwyq-0 email_contend">
            <input required autoCapitalize="none" autoComplete="email" 
            maxLength={160} placeholder="Email address" 
            autoCorrect="on" 
            dir="auto" 
            inputMode="email" 
            rows={1} 
            spellCheck="true" 
            type="email" 
            virtualkeyboardpolicy="auto" 
            aria-describedby="email-input-label"
             aria-label="Email" 
             aria-required="false" 
             className="email-input-field css-11aywtz r-6taxm2 r-14lw9ot r-z2wwpe r-rs99b7 r-1khnkhu r-1b43r93 r-eu3ka r-nwxazl r-1mkv55d r-ubg91z" 
             id="useremail" 
             data-testid="email-input"
             name='email'
             value={email}
             onChange={handleChange}
             />
          </div>
        </div>
       </div>
       <div className="styles__InputBoxWrapper-sc-yjr19k-3 sign_in_center_contend">
        <div className="styles__Container-sc-dzwwyq-0 sign_in_center_contend_box">
          <div className="styles__Container-sc-dzwwyq-0 email_contend password-container">
            <input required
            placeholder="Password"
            type="password" 
             aria-label="Password" 
             className="email-input-field css-11aywtz r-6taxm2 r-14lw9ot r-z2wwpe r-rs99b7 r-1khnkhu r-1b43r93 r-eu3ka r-nwxazl r-1mkv55d r-ubg91z" 
             id="userpassword" 
             name='password'
             value={password}
             onChange={handleChange}
             />
             <span className="toggle-password" id="togglePassword">
              <svg id="passwordHide" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_178_13892)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0011 18C8.63237 18 5.4638 16.0754 2.44714 11.9998C5.46419 7.92435 8.63259 6 12.0011 6C15.3699 6 18.5384 7.9246 21.5551 12.0002C18.5381 16.0757 15.3697 18 12.0011 18ZM12.0011 4C7.5541 4 3.72153 6.69306 0.396231 11.4248L-0.0078125 11.9997L0.396182 12.5747C3.72105 17.3066 7.55383 20 12.0011 20C16.4481 20 20.2807 17.3069 23.606 12.5752L24.0101 12.0003L23.6061 11.4253C20.2812 6.69339 16.4484 4 12.0011 4ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z" fill="#86898F"></path></g><defs><clipPath id="clip0_178_13892"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>
              <svg id='passwordShow' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_57_3880)"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.666 4.74742C22.0788 4.3805 22.1159 3.74843 21.749 3.33565C21.3821 2.92286 20.75 2.88568 20.3373 3.2526L17.6904 5.60537C15.9141 4.55556 14.021 3.99998 12.0011 3.99998C7.5541 3.99998 3.72153 6.69304 0.396231 11.4248L-0.0078125 11.9997L0.396182 12.5746C1.72195 14.4615 3.12847 16.0242 4.62251 17.2213L2.33725 19.2526C1.92447 19.6195 1.88729 20.2516 2.25421 20.6644C2.62113 21.0772 3.2532 21.1143 3.66598 20.7474L6.31249 18.395C8.08863 19.4445 9.98151 20 12.0011 20C16.4481 20 20.2807 17.3069 23.606 12.5752L24.0101 12.0003L23.6061 11.4253C22.2805 9.53872 20.8741 7.97616 19.3803 6.77915L21.666 4.74742ZM16.1043 7.0152C14.7689 6.33295 13.4023 5.99998 12.0011 5.99998C8.63259 5.99998 5.46419 7.92433 2.44714 11.9998C3.65324 13.6293 4.88362 14.9149 6.14137 15.8712L7.67403 14.5088C7.24544 13.7714 7 12.9143 7 12C7 9.23856 9.23858 6.99998 12 6.99998C13.1248 6.99998 14.1629 7.37142 14.9983 7.99834L16.1043 7.0152ZM16.3271 9.49309L17.8614 8.12923C19.119 9.08545 20.3492 10.3709 21.5551 12.0002C18.5381 16.0756 15.3697 18 12.0011 18C10.6001 18 9.23379 17.6671 7.89858 16.9851L9.00349 16.003C9.83855 16.6291 10.876 17 12 17C14.7614 17 17 14.7614 17 12C17 11.0864 16.755 10.2301 16.3271 9.49309ZM13.4511 9.37364C13.0211 9.13554 12.5264 8.99998 12 8.99998C10.3431 8.99998 9 10.3431 9 12C9 12.401 9.07868 12.7836 9.22146 13.1333L13.4511 9.37364ZM10.551 14.6274L14.7794 10.8688C14.9216 11.2179 15 11.5998 15 12C15 13.6568 13.6569 15 12 15C11.4745 15 10.9805 14.8649 10.551 14.6274Z" fill="#86898F"></path></g><defs><clipPath id="clip0_57_3880"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>
             </span>
          </div>

        </div>
       </div>
       <Loader loading={loading} />
       <button aria-label="Continue" height={40} role="button" type="submit" value="Continue" width="100%" className="styles__StyledButton-sc-8qc5s2-0 sign_in_center_contend_box_button">
        <div ><span className="styles__StyledText-sc-8qc5s2-1 sign_in_center_contend_box_button_text">Sign In</span></div>
        </button>
       </form>
       <div className="styles__NoAccountContainer-sc-yjr19k-4 sign_in_text_dont"><text className="styles__NoAccountText-sc-yjr19k-6 sign_in_text_dont_all">Don’t have an account? </text></div>
       <Link to='/Registration'><button aria-disabled="false" aria-label="Sign Up" height={40} role="button" type="button" value="Sign Up" width="100%" className="styles__StyledButton-sc-8qc5s2-0 sign_up_box"><div className='sing_up_box_text_contend'><span className="styles__StyledText-sc-8qc5s2-1 sing_up_box_text">Sign Up</span></div></button></Link>
       <div className='sign_up_line'></div><div />

       <div className="styles__AccountSubWrapper-sc-q68thf-5 sign_up_languagn_box">
         <div data-testid="language-selector" className="styles__LangSelectorWrapper-sc-z69cid-0 sign_up_languagn_box_label">
          <label htmlFor="language-selector-field" id="language-selector-label" aria-hidden="true" >Select a Language</label>
          <select aria-label="Select a Language" aria-labelledby="language-selector-label" id="language-selector-field">
            <option label="English" value="en" aria-selected="true">English</option><option label="Spanish" value="es">Spanish</option>
            <option label="Japanese" value="ja">Japanese</option><option label="German" value="de">German</option>
            <option label="Portuguese" value="pt">Portuguese</option><option label="French" value="fr">French</option>
          </select>
          </div>
          <button aria-label="Need Help?" role="button" type="button" className="styles__NeedHelpButton-sc-q68thf-6 sign_up_need">Need Help?</button>
          </div>

          </div></div></div>
       </div>

    </>
  )
};

export default SignIn;